import { useEffect, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import CampaignsDesktopList from "../../Campaigns/CampaignsDesktopList/campaignsDesktopList";

import { getActiveCampaigns } from "../../../redux/state/campaignSlice";

const ActiveCampaigns = () => {
    const dispatch = useDispatch();
    const { pathname, search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);

    const { communityId } = useParams();
    const activeCampaigns = useSelector(state => state.campaign.activeCampaigns, shallowEqual);

    useEffect(() => {
        const page = parseInt(query.get('page') ?? 1);
        if (!communityId) return;
        dispatch(getActiveCampaigns({ communityId, page, pageSize: 9 }));
    }, [
        communityId,
        query,
        dispatch
    ])

    return <CampaignsDesktopList
        data={activeCampaigns}
        tableUrl={pathname}
    />
}

export default ActiveCampaigns;